import { API_URL } from "./config";

const headers = {
  "Content-Type": "application/json"
};

export async function loadMonth(mk) {
  const res = await fetch(`${API_URL}/api/meses/${encodeURIComponent(mk)}`);
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`Error cargando mes: ${res.status} ${body}`);
  }
  return res.json();
}

export async function saveMonth(mk, data) {
  const res = await fetch(`${API_URL}/api/meses/${encodeURIComponent(mk)}`, {
    method: "POST",
    headers,
    body: JSON.stringify(data)
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`Error guardando mes: ${res.status} ${body}`);
  }
  return res.json();
}

export async function generateResumen(mk, tareas) {
  const res = await fetch(`${API_URL}/api/resumen-mensual/${encodeURIComponent(mk)}`, {
    method: "POST",
    headers,
    body: JSON.stringify({ tareas })
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`Error generando resumen: ${res.status} ${body}`);
  }
  return res.json();
}

export async function editTask(weekKey, taskId, cambios) {
  const res = await fetch(`${API_URL}/api/meses/${encodeURIComponent(weekKey)}/tareas/${encodeURIComponent(taskId)}`, {
    method: "PUT",
    headers,
    body: JSON.stringify(cambios)
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`Error editando tarea: ${res.status} ${body}`);
  }
  return res.json();
}
